import { useEffect } from 'react';

// Central UI glossary. Keeping the two languages side-by-side makes it easy for
// administrators to review terminology without touching application logic.
export const UI_PHRASES = [
  ['Danh thiếp nhân sự', 'Employee cards'],
  ['Quản lý nhân sự, duyệt nội dung và xuất QR để in', 'Manage employees, review content and export print-ready QR codes'],
  ['Thông báo', 'Notifications'], ['Đã đọc hết thông báo', 'You are all caught up'],
  ['Đánh dấu tất cả đã đọc', 'Mark all as read'], ['Đóng thông báo', 'Close notifications'],
  ['Đăng xuất', 'Sign out'], ['Cấu hình', 'Settings'], ['Cài đặt', 'Settings'], ['Nhân sự', 'Employees'],
  ['Mời nhân sự', 'Invite employee'], ['Tổng card', 'Total cards'], ['Chờ duyệt', 'Pending review'],
  ['Đã xuất bản', 'Published'], ['Cần sửa', 'Needs changes'], ['Chưa có card', 'No card'], ['Tất cả', 'All'],
  ['Tìm tên, email, chức danh hoặc đường dẫn card...', 'Search name, email, job title or card URL...'],
  ['Không tìm thấy kết quả phù hợp', 'No matching results'], ['Xóa bộ lọc', 'Clear filters'],
  ['Quản trị viên', 'Administrator'], ['Nhân viên', 'Employee'], ['Phân quyền', 'Change role'], ['Xóa', 'Delete'],
  ['Xem', 'View'], ['Sửa', 'Edit'], ['Duyệt', 'Approve'], ['Yêu cầu sửa', 'Request changes'],
  ['Chưa công khai', 'Not public'], ['Tạo thêm card', 'Create another card'], ['Tạo card cho nhân sự', 'Create employee card'],
  ['Danh thiếp của tôi', 'My business cards'], ['Hồ sơ cá nhân', 'Personal profile'],
  ['Tạo và chia sẻ danh thiếp chuyên nghiệp', 'Create and share a professional business card'],
  ['Tạo card đầu tiên', 'Create your first card'], ['Điền thông tin', 'Enter details'],
  ['Gửi admin duyệt', 'Submit for review'], ['Tải QR', 'Download QR'], ['Card của bạn', 'Your cards'],
  ['Theo dõi trạng thái và quản lý QR', 'Track status and manage QR codes'],
  ['Bạn chưa có danh thiếp', 'You do not have a card yet'], ['Bắt đầu tạo card', 'Create a card'],
  ['Chưa public', 'Not public'], ['QR danh thiếp', 'Card QR code'], ['Đóng', 'Close'],
  ['Tạo danh thiếp mới', 'Create a new card'], ['Đường dẫn card', 'Card URL'], ['Tạo card', 'Create card'], ['Hủy', 'Cancel'],
  ['Lưu', 'Save'], ['Đang lưu...', 'Saving...'], ['Quay lại', 'Back'], ['Xem trước', 'Preview'],
  ['Thông tin cá nhân', 'Personal information'], ['Thông tin liên hệ', 'Contact details'], ['Hình ảnh', 'Images'],
  ['Liên kết', 'Links'], ['Quyền riêng tư', 'Privacy'], ['Giao diện', 'Appearance'],
  ['Tên', 'First name'], ['Họ', 'Last name'], ['Chức danh', 'Job title'], ['Công ty', 'Company'],
  ['Địa điểm', 'Location'], ['Giới thiệu', 'Bio'], ['Số điện thoại', 'Phone number'], ['Website', 'Website'],
  ['Ảnh đại diện', 'Profile photo'], ['Ảnh bìa', 'Cover image'], ['Thêm liên kết', 'Add link'],
  ['Lưu card', 'Save card'], ['Đã lưu', 'Saved'], ['Đang tải...', 'Loading...'],
  ['Cấu hình hệ thống', 'System settings'], ['Organisation Name', 'Tên công ty'],
  ['Email SMTP', 'SMTP email'], ['Đã cấu hình', 'Configured'], ['Chưa cấu hình', 'Not configured'],
  ['Tài khoản SMTP', 'SMTP username'], ['Mật khẩu / App Password', 'Password / App Password'],
  ['Người gửi', 'Sender'], ['SSL trực tiếp', 'Direct SSL'], ['Lưu SMTP', 'Save SMTP'],
  ['Kiểm tra kết nối', 'Test connection'], ['Google Workspace domain', 'Google Workspace domain'],
  ['Tự động tạo tài khoản Member', 'Automatically provision members'],
  ['User Customisation Controls', 'Quyền tùy chỉnh của nhân sự'], ['Theme Colors', 'Màu giao diện'],
  ['App Theme', 'Kiểu giao diện'], ['Save Settings', 'Lưu cấu hình'], ['Saving...', 'Đang lưu...'],
  ['Quản lý nhân sự', 'Employee management'], ['Danh sách nhân sự', 'Employee list'],
  ['Lời mời đang chờ', 'Pending invitations'], ['Gửi lời mời', 'Send invitation'], ['Gửi lại', 'Resend'],
  ['Email mời đã được gửi thành công.', 'Invitation email sent successfully.'],
  ['Đăng nhập', 'Sign in'], ['Mật khẩu', 'Password'], ['Đăng nhập với Google', 'Sign in with Google'],
  ['Quản trị dự phòng', 'Fallback administrator'], ['Chỉ dành cho tài khoản Google Workspace', 'Google Workspace accounts only'],
  ['Chấp nhận lời mời', 'Accept invitation'], ['Tạo tài khoản', 'Create account'],
  ['Lưu vào danh bạ', 'Save contact'], ['Gọi điện', 'Call'], ['Gửi email', 'Send email'], ['Chia sẻ', 'Share'],
  ['Chế độ sáng', 'Light mode'], ['Chế độ tối', 'Dark mode'],
  ['Có card mới từ nhân sự', 'New employee card'], ['Card chưa xuất bản', 'Card is not published'],
  ['Thành công', 'Success'], ['Lỗi', 'Error'], ['Xác nhận', 'Confirm'], ['Tiếp tục', 'Continue']
  ,['Từ chối truy cập', 'Access Denied'], ['Không tìm thấy card', 'Card Not Found'],
  ['Không tìm thấy danh thiếp.', 'Card not found.'], ['Đang tải lời mời...', 'Loading invitation...'],
  ['Đang tải nhân sự...', 'Loading users...'], ['Lời mời không hợp lệ', 'Invitation Invalid'],
  ['Tạo người dùng mới', 'Create New User'], ['Mời người dùng', 'Invite User'],
  ['Vai trò', 'Role'], ['Chủ sở hữu', 'Owner'], ['Thành viên', 'Member'],
  ['Xác nhận mật khẩu', 'Confirm Password'], ['Đóng', 'Close'], ['Xóa bỏ', 'Remove'],
  ['Tải lên', 'Upload'], ['Đang tải ảnh lên...', 'Uploading image...'], ['Xem trước', 'Preview'],
  ['Cấu hình tổ chức', 'Organisation Settings'], ['Tên tổ chức', 'Organisation Name'],
  ['Tên tổ chức này sẽ được áp dụng cho tất cả card. Nhân sự không thể tự thay đổi.', 'This organisation name will be applied to all cards in your organisation. Users cannot change this.'],
  ['Kiểu giao diện ứng dụng', 'App Themes'], ['Chọn giao diện cho nền, thanh điều hướng và nút của ứng dụng.', 'Choose the look for the app UI (backgrounds, chrome, buttons).'],
  ['Màu hồ sơ', 'Profile Colors'], ['Quản lý bảng màu mà nhân sự có thể dùng cho card.', 'Manage the color palette available for user cards.'],
  ['Màu cơ bản', 'Base Color'], ['Màu phụ (không bắt buộc)', 'Secondary Color (optional)'],
  ['Tự động', 'Auto'], ['Màu phụ: Tự động (bổ trợ)', 'Secondary: Auto (complementary)'],
  ['Để trống để tự chọn màu bổ trợ', 'Leave blank to use auto (complementary) color'],
  ['Kiểu màu', 'Color Type'], ['Nền chuyển sắc', 'Gradient Background'], ['Hiệu ứng màu', 'Color Effects:'],
  ['Kiểu chuyển sắc:', 'Gradient Style:'], ['Kiểu nút:', 'Button Style:'], ['Kiểu liên kết:', 'Link Style:'], ['Kiểu chữ:', 'Text Style:'],
  ['Nút', 'Button'], ['Liên kết tùy chỉnh', 'Custom Links'], ['Cài đặt riêng tư', 'Privacy Settings'],
  ['Tùy chỉnh giao diện', 'Theme Customisation'], ['Tùy chỉnh hình ảnh', 'Image Customisation'],
  ['Tùy chỉnh liên kết', 'Links Customisation'],
  ['Kiểm soát việc nhân sự chọn màu giao diện cho card.', 'Control whether users can choose theme colors for their cards.'],
  ['Kiểm soát việc nhân sự tải ảnh đại diện và ảnh bìa.', 'Control whether users can upload custom avatars and banner images.'],
  ['Kiểm soát việc nhân sự thêm liên kết tùy chỉnh.', 'Control whether users can add custom links to their cards.'],
  ['Kiểm soát việc nhân sự thay đổi cài đặt riêng tư.', 'Control whether users can change privacy settings on their cards.'],
  ['Kiểm soát những nội dung nhân sự được phép tùy chỉnh trên card.', 'Control what users in your organisation can customise on their cards.'],
  ['Bị tổ chức khóa', 'Locked by Organisation'], ['Đã khóa', 'Locked'],
  ['Email mời sẽ được gửi tới địa chỉ này', 'An invitation email will be sent to this address'],
  ['Bạn không có quyền quản lý nhân sự.', "You don't have permission to manage users."],
  ['QR chỉ chứa liên kết khả dụng khi bạn đang trực tuyến.', "Link-only QR is available when you're online."]
];

const nodeSource = new WeakMap();
const attributeSource = new WeakMap();

const translateValue = (value, language) => {
  const leading = value.match(/^\s*/)?.[0] || '';
  const trailing = value.match(/\s*$/)?.[0] || '';
  const core = value.trim();
  if (!core) return value;
  for (const [vi, en] of UI_PHRASES) {
    if (core === vi || core === en) return `${leading}${language === 'vi' ? vi : en}${trailing}`;
  }
  return value;
};

const translateTree = (root, language) => {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    if (['SCRIPT', 'STYLE', 'CODE'].includes(node.parentElement?.tagName)) continue;
    if (!nodeSource.has(node)) nodeSource.set(node, node.nodeValue);
    node.nodeValue = translateValue(nodeSource.get(node), language);
  }
  root.querySelectorAll?.('[placeholder], [title], [aria-label]').forEach(element => {
    if (!attributeSource.has(element)) attributeSource.set(element, {});
    const source = attributeSource.get(element);
    ['placeholder', 'title', 'aria-label'].forEach(name => {
      if (!element.hasAttribute(name)) return;
      if (source[name] === undefined) source[name] = element.getAttribute(name);
      element.setAttribute(name, translateValue(source[name], language));
    });
  });
};

export const useInterfaceLanguage = (language) => {
  useEffect(() => {
    document.documentElement.lang = language;
    translateTree(document.body, language);
    const observer = new MutationObserver(mutations => {
      observer.disconnect();
      mutations.forEach(mutation => {
        if (mutation.type === 'characterData') translateTree(mutation.target.parentElement, language);
        mutation.addedNodes.forEach(node => translateTree(node.nodeType === 1 ? node : node.parentElement, language));
      });
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [language]);
};
